import { Component, OnInit, Inject } from '@angular/core';
import { FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

import { ComponentBase, DialogData } from '@definitiv-packages/angular-dba-library';

import { CreateStandortComponent } from '../create-standort/create-standort.component';
import { ProjectLanguage } from '../../types/ProjectLanguage';
 
import { ProjektPermissionService } from '../../services/projektpermission.service';
import { DebitorModelView } from '../../types/DebitorModel';
import { ObjektModel, ObjektModelView } from '../../types/ObjektModel';
import { StandortModelView, StandortModel } from '../../types/StandortModel';
import { SysLandModel } from '../../types/SysLandModel';
import { ObjektService } from '../../services/Models/ObjektModel.service';
import { StandortViewService } from '../../services/Views/StandortModelView.service';
import { StandortService } from '../../services/Models/StandortModel.service';
import { DebitorViewService } from '../../services/Views/DebitorModelView.service';
import { SysLandService } from '../../services/Models/SysLandModel.service';

@Component({
  selector: 'app-create-objekt',
  templateUrl: './create-objekt.component.html',
  styleUrls: ['./create-objekt.component.scss'],
  standalone: false
})
export class CreateObjektComponent extends ComponentBase<ProjectLanguage> implements OnInit {
  //#region 
  public Title: string = "";
  public objekt: ObjektModel | null = null;

  public debitorList: DebitorModelView[] = [];
  public standortList: StandortModelView[] = [];
  public landList: SysLandModel[] = [];

  public selectedstandortModelView : StandortModelView| null=null;
  private DebitorControl : FormControl<DebitorModelView|null> = new FormControl<DebitorModelView|null>(null, [Validators.required ]);
  private BezeichnungControl: FormControl<string | null> = new FormControl<string | null>(null, [Validators.required, Validators.maxLength(100)]);
  public StrasseControl: FormControl<string | null> = new FormControl<string | null>(null, [Validators.maxLength(100)]);
  public PLZControl: FormControl<string | null> = new FormControl<string | null>(null, [Validators.maxLength(10)]);
  public OrtControl: FormControl<string | null> = new FormControl<string | null>(null, [Validators.maxLength(100)]);
  private LandControl: FormControl<SysLandModel | null> = new FormControl<SysLandModel | null>(null);
  private StandortControl: FormControl<StandortModelView | null> = new FormControl<StandortModelView | null>(null);
  private WartungAbControl: FormControl<Date | null> = new FormControl<Date | null>(null);
  private WartungIntervallControl: FormControl<number | null> = new FormControl<number | null>(null, Validators.max(36));

  public FormGroup = new UntypedFormGroup({
    bezeichnungControl: this.BezeichnungControl,
    debitorControl: this.DebitorControl,
    strasseControl: this.StrasseControl,
    plzControl: this.PLZControl,
    ortControl: this.OrtControl,
    landControl: this.LandControl,
    standortControl: this.StandortControl,
    wartungabControl: this.WartungAbControl,
    wartungintervallControl: this.WartungIntervallControl
  });
  //#endregion

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData<ObjektModelView>,
    public dialogRef: MatDialogRef<CreateObjektComponent>,
    public objektService: ObjektService,
    public standortViewService: StandortViewService,
    public standortService: StandortService,
    public debitorService: DebitorViewService,
    public syslandService: SysLandService,
      public permissionService: ProjektPermissionService,
      private dialog: MatDialog
  ) { super(); }

  public async ngOnInit() {
    this.loading = true;
    this.debitorList = await this.debitorService.getList();
    this.standortList = await this.standortViewService.getList();
    this.landList = await this.syslandService.getList();

    if (this.data.mode == 'create') {
      this.Title = this.languageService.getText(this.language.objekterstellen);
    } else if (this.data.mode == 'edit') {
      this.Title = this.languageService.getText(this.language.objektbearbeiten);
    }

    if(!this.data.data?.ObjektID && this.data.data?.DebitorID){
        this.debitorList = this.debitorList.filter(x=>x.DebitorID==this.data.data?.DebitorID)
    }
    if(!this.data.data?.ObjektID && this.data.data?.StandortID){
        this.standortList = this.standortList.filter(x=>x.StandortID==this.data.data?.StandortID)
    }
  
    
    if (this.data.data?.ObjektID) {

      this.objekt = await this.objektService.get(this.data.data.ObjektID!);
      this.BezeichnungControl.setValue(this.objekt.Bezeichnung);

      this.StrasseControl.setValue(this.objekt.Strasse);
      this.PLZControl.setValue(this.objekt.PLZ);
      this.OrtControl.setValue(this.objekt.Ort);
      this.StandortControl.setValue(this.standortList.find(x=>x.StandortID == this.objekt?.StandortID)!);
      
      var found = this.standortList.find(x=>x.StandortID == this.objekt?.StandortID);
      this.DebitorControl.setValue(this.debitorList.find (x=>x.DebitorID == found?.DebitorID)!);


      this.StandortControl.setValue(this.standortList.find (x=>x.StandortID == found?.StandortID)!) ;

      if (this.objekt.LandID)
        this.LandControl.setValue(this.landList.find(x => x.LandID == this.objekt?.LandID)!);
    }
    else {
      this.objekt = {} as ObjektModel;
      if(!this.data.data?.ObjektID && this.data.data?.StandortID){
        this.standortList = this.standortList.filter(x=>x.StandortID==this.data.data?.StandortID)
        this.StandortControl.setValue(this.standortList[0]) ;
      }

    }
    this.loading = false;
  }

  public async Save(): Promise<void> {

    
    this.FormGroup.markAllAsTouched();
    this.FormGroup.updateValueAndValidity();
    if (this.FormGroup.valid) {

      this.loading = true;
      this.objekt = new ObjektModel();

      if (this.data.mode == 'edit' && this.data.data)
        this.objekt.ObjektID = this.data.data?.ObjektID!;

      this.objekt.Bezeichnung = this.BezeichnungControl.value!;

      this.objekt.Strasse = this.StrasseControl.value ?? '';
      this.objekt.PLZ = this.PLZControl.value ?? '';
      this.objekt.Ort = this.OrtControl.value ?? '';


      if (this.LandControl.value)
        this.objekt.LandID = this.LandControl.value?.LandID;
      
      
      if(this.StandortControl.value){
          this.objekt.StandortID = this.StandortControl.value.StandortID;
      }else{
          var Obj= new StandortModel();
          Obj.Bezeichnung = this.objekt.Bezeichnung;
          Obj.DebitorID = this.DebitorControl.value?.DebitorID!;
          Obj.Strasse   = this.StrasseControl.value!;
          Obj.Ort       = this.OrtControl.value!;
          Obj.PLZ       = this.PLZControl.value!;
          Obj.LandID       = this.LandControl.value?.LandID!;
          var Standort = await this.standortService.post(Obj);

          this.objekt.StandortID = Standort.StandortID;
      }

      if (this.objekt.ObjektID > 0)       //Update
        var Item = await this.objektService.put(this.objekt.ObjektID, this.objekt)
      else                                  // Insert
        var Item = await this.objektService.post(this.objekt)

      this.loading = false;
      this.dialogRef.close(Item);
    }
  }

  getfilterStandortList(){
      if(!this.DebitorControl.value?.DebitorID) return[];
      return this.standortList.filter(x=>x.DebitorID == this.DebitorControl.value?.DebitorID);
  }
  openMaps() {
    var adress = this.StrasseControl.value + ", " + this.PLZControl.value + " " + this.OrtControl.value;
    const url = "https://www.google.com/maps?q=" + adress + '&z=16';
    window.open(url, '_blank');
  }

   public OpenCreateStandortDialog=():Promise<StandortModelView>=>{
    return new Promise<StandortModelView>((resolve, reject) => {

      var StandortModelView : StandortModelView={
          StandortID:  0,
          DebitorID:this.DebitorControl.value?.DebitorID!,
          Strasse :"",
          PLZ:"",
          Ort:"",
          LandID:null,
          Bezeichnung : ""
      }
      
      var data = new DialogData(StandortModelView, 'create');
      this.dialog.open(CreateStandortComponent, { data: data }).afterClosed().subscribe((item: StandortModelView) => {
        if(item){
            this.standortList.push(item);
        }
        
        resolve(item);
      });
      
    });    
  }    
  public Abbrechen() {
    this.dialogRef.close();
  }
}
